import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from './assets/img/green-x-logo-black.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = { class: "lang" }
const _hoisted_5 = { class: "language-container" }
const _hoisted_6 = { class: "lang-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "header-h5" }
const _hoisted_9 = { class: "select" }
const _hoisted_10 = { class: "nav" }
const _hoisted_11 = { class: "lang-h5" }
const _hoisted_12 = { class: "language-container" }
const _hoisted_13 = { class: "svg-h5" }
const _hoisted_14 = { class: "lang-list" }
const _hoisted_15 = ["onClick"]

import {reactive, watch, ref} from "vue";
import { useRoute, useRouter} from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const lan = ref();
const isSelect = ref<boolean>(false);
const langList = reactive([
    {
        lang: 'zh_CN',
        title: '简体中文'
    },
    {
        lang: 'en_US',
        title: 'English'
    },
    {
        lang: 'ko_KR',
        title: '한국어'
    },
    {
        lang: 'ja_JP',
        title: '日本語'
    },
    {
        lang: 'id_ID',
        title: 'Bahasa'
    },
])


watch(() => route.path, () => {
    lan.value = localStorage.getItem('lang');
    const l:any = route.params.lang;
    // 监听路由路径变化
    if (l !== lan.value) {
        localStorage.setItem('lang', l);
        reloadPage();
    }
});
const selectLang = (lang: string) => {
    isSelect.value = false;
    router.push({
        params: {
            lang
        }
    });
}

const reloadPage = () => {
   window.location.reload();
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("a", { href: "/" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "green-"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["nav-menu", {'isActive': _unref(route).name === 'home'}])
          }, [
            _createVNode(_component_router_link, {
              to: `/${lan.value}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('首页')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["nav-menu", {'isActive': _unref(route).name === 'notice'}])
          }, [
            _createVNode(_component_router_link, {
              to: `/${lan.value}/notice`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('公告')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["nav-menu", {'isActive': _unref(route).name === 'project'}])
          }, [
            _createVNode(_component_router_link, {
              to: `/${lan.value}/project`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('RWA数字股票')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("svg", {
            class: "language-icon",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M15.23 20.403a9.011 9.011 0 005.684-7.153h-3.942c-.147 2.86-.793 5.388-1.741 7.153zm-.757-7.153c-.178 4.102-1.217 7.25-2.473 7.25-1.256 0-2.295-3.148-2.473-7.25h4.946zm0-2.5H9.527C9.705 6.648 10.744 3.5 12 3.5c1.256 0 2.295 3.148 2.473 7.25zm2.499 0h3.942a9.01 9.01 0 00-5.683-7.153c.948 1.765 1.594 4.293 1.741 7.153zm-9.936 0c.147-2.862.793-5.392 1.743-7.156a9.01 9.01 0 00-5.693 7.156h3.95zm0 2.5h-3.95a9.01 9.01 0 005.693 7.157c-.95-1.765-1.596-4.295-1.743-7.157z",
              fill: "currentColor"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langList, (item, index) => {
              return (_openBlock(), _createElementBlock("p", {
                onClick: ($event: any) => (selectLang(item.lang)),
                key: index
              }, _toDisplayString(item.title), 9, _hoisted_7))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("header", _hoisted_8, [
      _createElementVNode("div", {
        class: "header-h5-container",
        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (isSelect.value = false))
      }, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "logo" }, [
          _createElementVNode("a", { href: "/" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "green-"
            })
          ])
        ], -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["spread", {'isSelect': isSelect.value}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isSelect.value = !isSelect.value))
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("span", null, null, -1),
          _createElementVNode("span", null, null, -1),
          _createElementVNode("span", null, null, -1)
        ]), 2),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: `/${lan.value}`,
              class: _normalizeClass({'isActive': _unref(route).name === 'home'}),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isSelect.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('首页')), 1)
              ]),
              _: 1
            }, 8, ["to", "class"]),
            _createVNode(_component_router_link, {
              to: `/${lan.value}/notice`,
              class: _normalizeClass({'isActive': _unref(route).name === 'notice'}),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (isSelect.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('公告')), 1)
              ]),
              _: 1
            }, 8, ["to", "class"]),
            _createVNode(_component_router_link, {
              to: `/${lan.value}/project`,
              class: _normalizeClass({'isActive': _unref(route).name === 'project'}),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (isSelect.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('RWA数字股票')), 1)
              ]),
              _: 1
            }, 8, ["to", "class"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[8] || (_cache[8] = _createElementVNode("svg", {
                    class: "language-icon",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M15.23 20.403a9.011 9.011 0 005.684-7.153h-3.942c-.147 2.86-.793 5.388-1.741 7.153zm-.757-7.153c-.178 4.102-1.217 7.25-2.473 7.25-1.256 0-2.295-3.148-2.473-7.25h4.946zm0-2.5H9.527C9.705 6.648 10.744 3.5 12 3.5c1.256 0 2.295 3.148 2.473 7.25zm2.499 0h3.942a9.01 9.01 0 00-5.683-7.153c.948 1.765 1.594 4.293 1.741 7.153zm-9.936 0c.147-2.862.793-5.392 1.743-7.156a9.01 9.01 0 00-5.693 7.156h3.95zm0 2.5h-3.95a9.01 9.01 0 005.693 7.157c-.95-1.765-1.596-4.295-1.743-7.157z",
                      fill: "currentColor"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('语言')), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langList, (item, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      onClick: ($event: any) => (selectLang(item.lang)),
                      class: _normalizeClass({'isSelect': item.lang === lan.value}),
                      key: index
                    }, _toDisplayString(item.title), 11, _hoisted_15))
                  }), 128))
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, isSelect.value]
        ])
      ], 32)
    ]),
    _createVNode(_component_router_view)
  ], 64))
}
}

})